// Copyright 2025. WebPros International GmbH. All rights reserved.

export const LOCATIONS = {
    TABLE: 'locations-table',
    VISIBILITY: 'locations-visibility',
    DEFAULT: 'locations-default',
};
